<nz-space class="mobile-report-control">
    <app-cs-select [(ngModel)]="from" class="report-control" (ngModelChange)="fromChange.emit($event)"
      valueField="docCode">
    </app-cs-select>
    <span class="text-center">
      <span nz-icon nzType="swap-right" nzTheme="outline"></span>
    </span>
    <app-cs-select [(ngModel)]="to" class="report-control" (ngModelChange)="toChange.emit($event)" valueField="docCode">
    </app-cs-select>
</nz-space>
  